module.exports = __webpack_public_path__ + "img/undraw_quitting_time_dm-8-t.5ed04682.svg";